module.exports = __webpack_public_path__ + "fonts/hinted-HalisGR-Regular.woff2";